import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  ImagesTabRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  TabsRoot: {
    maxWidth: '20%',
    minWidth: '20%'
  },
  TabsFlexStart: {
    alignItems: 'flex-start'
  },
  TabLabel: {
    alignItems: 'flex-start'
  },
  ImageCard: {
    width: 195,
    padding: 2,

    '& .MuiCardActions-root': {
      padding: '0'
    },

    '& img': {
      height: 120,
      display: 'block',
      objectFit: 'contain',
      borderRadius: 5
    },

    '& .MuiCardContent-root': {
      padding: 0
    },

    '& .MuiCheckbox-root': {
      padding: 5
    }
  },
  ImageCardSelected: {
    boxShadow: `0 0 1px 1px ${theme.palette.primary.light}`
  },
  ImagesGalleryRoot: {
    gap: 15,
    paddingTop: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  LinearProgress: {
    width: '100%'
  }
}));
